import RMSvgIcon, { RMSvgIconProps } from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { memo } from 'react';

interface Props {
    containerClassName?: string;
    svgProps?: Omit<RMSvgIconProps, 'name'>;
    textClassName?: string;
    text?: string;
}

const NoImage = (props: Props) => {
    const {
        containerClassName = 'opacity-50 align-center content-center flex flex-col',
        textClassName = 'font-italic mt-1',
        svgProps= { fill: '#333',  width: 30, height: 30}
    } = props;
    return (
        <div id='generic-noimage-wrapper' className={containerClassName}>
            <RMSvgIcon id='generic-noimage-svg-image-icon' name="ImageIcon" {...svgProps} />
            <div id='generic-noimage-noimage-text' className={textClassName}>No image</div>
        </div>
    );
}

export default memo(NoImage);
